/**
 * One River Tai Chi - Custom Storefront Scripts
 * Handles interactive enhancements across different pages.
 */
function initCustomScripts() {
  // --- 1. Smooth Scroll from Hero CTA to Courses Grid ---
  const browseBtn = document.querySelector('.ort-collection-hero__btn--primary');
  if (browseBtn) {
    browseBtn.addEventListener('click', (e) => {
      const target = document.getElementById('ResultsList');
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth' });
      }
    });
  }

  // --- 2. Smooth Scroll from Private Sessions Card to Contact Form ---
  const scrollCard = document.querySelector('.ort-scroll-card');
  if (scrollCard) {
    scrollCard.addEventListener('click', (e) => {
      const target = document.getElementById('ort-contact-form-section');
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth' });
      }
    });
  }

  // --- 3. Robust Scroll Reveal via IntersectionObserver & MutationObserver ---
  if ('IntersectionObserver' in window) {
    const revealObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        // Trigger if intersecting OR if the element is already above the viewport (scrolled past)
        const isAboveViewport = entry.boundingClientRect && entry.boundingClientRect.top < 0;
        if (entry.isIntersecting || isAboveViewport) {
          entry.target.classList.add('visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.05, rootMargin: '0px 0px 50px 0px' });

    const REVEAL_SELECTOR = '.reveal, .reveal-fade, .reveal-fade-up, .reveal-slide-left, .reveal-slide-right, .reveal-scale';

    const isRevealElement = (el) => {
      if (!el.classList) return false;
      return el.classList.contains('reveal') ||
             el.classList.contains('reveal-fade') ||
             el.classList.contains('reveal-fade-up') ||
             el.classList.contains('reveal-slide-left') ||
             el.classList.contains('reveal-slide-right') ||
             el.classList.contains('reveal-scale');
    };

    // Helper to observe elements
    const observeElements = (container) => {
      if (!container) return;
      
      // Use double requestAnimationFrame to ensure the browser has completed layout and paint
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          const elements = container.querySelectorAll ? container.querySelectorAll(REVEAL_SELECTOR) : [];
          elements.forEach((el) => {
            if (!el.classList.contains('visible')) {
              revealObserver.observe(el);
            }
          });

          // Also check if the container itself is a reveal element
          if (isRevealElement(container) && !container.classList.contains('visible')) {
            revealObserver.observe(container);
          }
        });
      });
    };

    // Run initially for existing elements
    observeElements(document.body || document.documentElement);

    // Fallback: trigger remaining elements when reaching the bottom of the page
    const triggerBottomElements = () => {
      const threshold = 50; // trigger if within 50px of the bottom
      const isAtBottom = (window.innerHeight + window.scrollY) >= (document.documentElement.scrollHeight - threshold);
      if (isAtBottom) {
        document.querySelectorAll(REVEAL_SELECTOR).forEach((el) => {
          if (!el.classList.contains('visible')) {
            el.classList.add('visible');
            revealObserver.unobserve(el);
          }
        });
      }
    };
    window.addEventListener('scroll', triggerBottomElements, { passive: true });
    window.addEventListener('resize', triggerBottomElements, { passive: true });

    // Watch for dynamic DOM insertions (like page transitions or theme editor reloads)
    // Defer dynamic mutation observing until the page has fully loaded to avoid triggers during parsing
    const startMutationObserver = () => {
      const domObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE) {
              observeElements(node);
            }
          });
        });
      });

      domObserver.observe(document.documentElement, {
        childList: true,
        subtree: true
      });
    };

    if (document.readyState === 'complete') {
      startMutationObserver();
    } else {
      window.addEventListener('load', startMutationObserver);
    }
  } else {
    // Fallback: show everything immediately
    const REVEAL_SELECTOR = '.reveal, .reveal-fade, .reveal-fade-up, .reveal-slide-left, .reveal-slide-right, .reveal-scale';
    const isRevealElement = (el) => {
      if (!el.classList) return false;
      return el.classList.contains('reveal') ||
             el.classList.contains('reveal-fade') ||
             el.classList.contains('reveal-fade-up') ||
             el.classList.contains('reveal-slide-left') ||
             el.classList.contains('reveal-slide-right') ||
             el.classList.contains('reveal-scale');
    };

    const revealAll = () => {
      document.querySelectorAll(REVEAL_SELECTOR).forEach((el) => el.classList.add('visible'));
    };
    revealAll();
    
    // Also run on dynamic insertions
    const domObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            const elements = node.querySelectorAll ? node.querySelectorAll(REVEAL_SELECTOR) : [];
            elements.forEach((el) => el.classList.add('visible'));
            if (isRevealElement(node)) {
              node.classList.add('visible');
            }
          }
        });
      });
    });
    domObserver.observe(document.documentElement, { childList: true, subtree: true });
  }

  // --- 4. Navigation Solidify on Scroll ---
  const mainNav = document.getElementById('main-nav') || document.querySelector('.header-wrapper') || document.getElementById('header-component');
  if (mainNav) {
    window.addEventListener('scroll', () => {
      mainNav.style.background =
        window.scrollY > 60 ? 'rgba(14, 26, 24, 0.98)' : 'rgba(14, 26, 24, 0.9)';
    }, { passive: true });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCustomScripts);
} else {
  initCustomScripts();
}
